import React, { ReactElement, useRef } from "react";
import { AppStoreButton } from "./app-store-button";
import { STORY_COPIES, STORY_PHOTOS } from "./story-content";
import {
  AfterStory,
  Brand,
  ChapterMarks,
  Copy,
  CopyFrame,
  Edition,
  Eyebrow,
  Grain,
  Header,
  HeaderActions,
  HeroActions,
  HeroTitle,
  InviteLink,
  Lead,
  Main,
  Nav,
  Portal,
  PortalImage,
  PortalPicture,
  Progress,
  ProgressBar,
  ScrollNote,
  Stage,
  Story,
  StoryGlobalStyle,
  StoryTitle,
} from "./styled";
import { useScrollStory } from "./use-scroll-story";

export const ScrollStory: React.FC = (): ReactElement => {
  const sectionRef = useRef<HTMLElement>(null);
  const stageRef = useRef<HTMLDivElement>(null);
  const portalRef = useRef<HTMLElement>(null);
  const headerRef = useRef<HTMLElement>(null);

  useScrollStory({ sectionRef, stageRef, portalRef, headerRef });

  return (
    <>
      <StoryGlobalStyle />
      <Grain aria-hidden="true" />

      <Header ref={headerRef}>
        {/*<Brand href="#top" aria-label="Plumme — наверх">*/}
        {/*  plumme*/}
        {/*</Brand>*/}

        {/*<Nav aria-label="Основная навигация">*/}
        {/*  <a href="#story">О Plumme</a>*/}
        {/*  <a href="#story">Клубы</a>*/}
        {/*  <a href="#after">Для клубов</a>*/}
        {/*</Nav>*/}

        {/*<HeaderActions>*/}
        {/*  <InviteLink href="#after">У меня есть инвайт</InviteLink>*/}
        {/*  <AppStoreButton variant="header" />*/}
        {/*</HeaderActions>*/}
      </Header>

      <Main id="top">
        <Story ref={sectionRef} id="story" aria-label="История Plumme">
          <Stage ref={stageRef}>
            <Copy aria-live="polite">
              {STORY_COPIES.map((item, index) => (
                <CopyFrame key={item.title} data-copy={index}>
                  <Eyebrow>{item.eyebrow}</Eyebrow>

                  {item.heading === "h1" ? (
                    <HeroTitle>{item.title}</HeroTitle>
                  ) : (
                    <StoryTitle>{item.title}</StoryTitle>
                  )}

                  {item.description && <Lead>{item.description}</Lead>}

                  {(item.showStoreButton || item.showScrollNote) && (
                    <HeroActions>
                      {item.showStoreButton && <AppStoreButton />}
                      {/*{item.showScrollNote && (*/}
                      {/*  <ScrollNote>Скролько, чтобы войти</ScrollNote>*/}
                      {/*)}*/}
                    </HeroActions>
                  )}
                </CopyFrame>
              ))}
            </Copy>

            <Portal ref={portalRef} aria-label="Жизнь внутри Plumme">
              {STORY_PHOTOS.map((photo, index) => (
                  <PortalPicture key={photo.src}>
                    <source
                        media="(max-width: 900px)"
                        srcSet={photo.mobileSrc}
                    />

                    <PortalImage
                        src={photo.src}
                        alt={photo.alt}
                        data-photo={index}
                        $objectPosition={photo.objectPosition}
                        loading={index < 2 ? "eager" : "lazy"}
                        fetchPriority={index === 0 ? "high" : "auto"}
                        decoding="async"
                    />
                  </PortalPicture>
              ))}
            </Portal>

            <ChapterMarks aria-hidden="true">
              {STORY_COPIES.map((item, index) => (
                <span key={item.title} data-chapter-mark={index} />
              ))}
            </ChapterMarks>

            {/*<Edition aria-hidden="true">Plumme · Moscow · 2026</Edition>*/}
            <Progress aria-hidden="true">
              <ProgressBar />
            </Progress>
          </Stage>
        </Story>

        {/*<AfterStory id="after">*/}
        {/*  <p>*/}
        {/*    Не ещё одна социальная сеть. Пространство, где город становится*/}
        {/*    ближе.*/}
        {/*  </p>*/}
        {/*</AfterStory>*/}
      </Main>
    </>
  );
};
